import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout, getCurrentUser, isSystemAdmin, isAccountAdmin } from '../../services/auth';
import './UserMenu.css';

const UserMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const user = getCurrentUser();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleExcels = () => {
    setIsOpen(false);
    navigate('/excel-config');
  };

  const handleAccounts = () => {
    setIsOpen(false);
    navigate('/accounts');
  };

  const handleUsers = () => {
    setIsOpen(false);
    navigate('/users');
  };

  const handleConsumption = () => {
    setIsOpen(false);
    navigate('/consumption');
  };

  const handleTariffs = () => {
    setIsOpen(false);
    navigate('/tariffs');
  };

  const getInitial = () => {
    if (user && user.first_name) {
      return user.first_name.charAt(0).toUpperCase();
    }
    return 'U';
  };

  const isSysAdmin = isSystemAdmin();
  const isAdmin = isAccountAdmin();

  return (
    <div className="user-menu-container" ref={menuRef}>
      <button className="btn-user" onClick={() => setIsOpen(!isOpen)}>
        {getInitial()}
      </button>

      {isOpen && (
        <div className="user-menu-dropdown">
          <button onClick={handleExcels} className="menu-item">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="16" y1="13" x2="8" y2="13"/>
              <line x1="16" y1="17" x2="8" y2="17"/>
              <polyline points="10 9 9 9 8 9"/>
            </svg>
            Excels generados
          </button>

          {isSysAdmin && (
            <button onClick={handleAccounts} className="menu-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
              Cuentas
            </button>
          )}

          {isAdmin && (
            <button onClick={handleUsers} className="menu-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2m8-10a4 4 0 100-8 4 4 0 000 8zm8 0c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3z"/>
              </svg>
              Usuarios
            </button>
          )}

          {(isSysAdmin || isAdmin) && (
            <button onClick={handleConsumption} className="menu-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 20V10"/>
                <path d="M18 20V4"/>
                <path d="M6 20v-4"/>
              </svg>
              Consumo
            </button>
          )}

          {isSysAdmin && (
            <button onClick={handleTariffs} className="menu-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/>
                <line x1="7" y1="7" x2="7.01" y2="7"/>
              </svg>
              Tarifas
            </button>
          )}

          <button onClick={handleLogout} className="menu-item">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4m7 14l5-5-5-5m5 5H9"/>
            </svg>
            Cerrar sesión
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;